import { HomeMenuThemeSizeConfig } from './types';

const small: HomeMenuThemeSizeConfig = {
  BoxMenu: {},
};

export default small;
